import styled from "styled-components";
import BREAKPOINTS from "../../Theme/Breakpoints";
import COLORS from "../../Theme/Colors";

export const Wrapper = styled.section`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.2rem;
  justify-content: center;
  align-items: center;
  padding: 2rem 0 0;

  ${BREAKPOINTS.TABLET} {
    margin: 0 2rem;
  }

  ${BREAKPOINTS.MOBILE} {
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
  }
`;

export const ImageContainer = styled.div`
  position: relative;
  width: 100%;
  cursor: pointer;
  overflow: hidden;
  border-radius: 12px;

  ${({ isActive }) =>
    isActive &&
    `
    img {
      transform: scale(1.08);
      filter: brightness(0.7);
    }
    div {
      opacity: 1;
    }
  `}
`;

export const StyledImage = styled.img`
  display: flex;
  width: 100%;
  transition: transform 0.3s ease, filter 0.3s ease;
`;

export const HoverText = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: opacity 0.3s ease;
  color: ${COLORS.white};
  font-size: 1.5rem;
  font-weight: 600;
  font-family: "Poppins", sans-serif;

  ${BREAKPOINTS.MOBILE} {
    font-size: 1.1rem;
  }
`;
